export const getClassName = (isMenuShown: any) => {
  const className = "MapWrapper";

  if (isMenuShown) return className + "--menuShown";
  if (isMenuShown === false) return className + "--menuHidden";
  return className;
};

export const getPlaces = (places: any) => {
  return places.filter((place: any) => place.isVisible);
};

export const getAirports = (airports: any) => {
  return airports.filter((airport: any) => airport.isVisible);
};

export const getRoutes = (routes: any) => {
  return routes.filter((route: any) => route.isVisible);
};
